export default {
    namespaced: true,

    state: () => ({
        consumptions: [],
        loaging: false,
        invoice: '',
        invoices: []
    }),

    getters: {
        consumptions(state) {
            return state.consumptions.map((item, i) => {
                item.sl = i + 1;
                return item;
            });
        },

        loading(state) {
            return state.loading;
        },

        invoice(state) {
            return state.invoice;
        },

        invoices(state) {
            return state.invoices.map((item, i) => {
                item.sl = i + 1;
                return item;
            })
        }
    },

    mutations: {
        populateConsumption(state, consumptions) {
            state.consumptions = consumptions;
        },

        populateLoading(state, loading) {
            state.loaging = loading;
        },

        populateInvoice(state, invoice) {
            state.invoice = invoice;
        }, 

        populateInvoices(state, invoices) {
            state.invoices = invoices;
        }

    },

    actions: {
        async getConsumptions(context, { apiArg = {}, options = {} } = {}) {
            context.commit('populateLoading', true);
            await axios.post('get-consumptions', apiArg, {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            })
            .then(res => {
                context.commit('populateConsumption', res.data.consumptions);
            })
            .catch(error => this.dispatch('snackbar/error', error.message))
            context.commit('populateLoading', false);
        },

        async getConsumption(context, payload) {
            let response = null
            await axios.post('get-consumption', payload, {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }                
            })
            .then(res => {
                response = res.data.consumption
            })
            .catch(error => this.dispatch('snackbar/error', error.response.data.message))
            return response
        },

        async saveConsumptions(context, consumption) {
            let response = {isSuccess: false }
            let url = 'add-consumption';

            if(consumption.id != null) {
                url = 'update-consumption';
            }

            await axios.post(url, consumption, {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            }) 
            .then(res => {
                response.isSuccess = true;
                response.id = res.data.id;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getConsumptions');
            })
            .catch( err => {
                response.isSuccess = false;
                this.dispatch('snackbar/error', err.response.data.message);
            })

            return response;
        },

        async deleteConsumption(context, id) {
            let isSuccess = false;
            let url = 'delete-consumption';

            await axios.post(url, id, {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            })
            .then(res => {
                isSuccess = true;
                this.dispatch('snackbar/success', res.data.message);
                context.dispatch('getConsumptions');
            })
            .catch(err => {
                isSuccess = false;
                this.dispatch('snackbar/error', err.response.data.message);
            })
            
            return isSuccess;
        },

        async getInvoices(context) {
            await axios.get('get-consumption-invoice', {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            })
            .then(res => {
                context.commit('populateInvoice', res.data.code);
            })
            .catch(err => {
                this.dispatch('snackbar/error', error.response.data.message)
            })
        },

        async getConsumptionInvoice(context) {
            await axios.get('get-consumption-report', {
                headers: {
                    Authorization: this.getters['auth/jwt']
                }
            })
            .then(res => {
                context.commit('populateInvoices', res.data.invoices);
            })
            .catch(err => {
                this.dispatch('snackbar/error', error.response.data.message)
            })
        }
    }
}